export const SET_ITEMS = "SET_ITEMS";
export const UPDATE_ITEM_VALUE = "UPDATE_ITEM_VALUE";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const ADD_ITEM = "ADD_ITEM";
